var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"a-arrow"},[_c('button',_vm._g({staticClass:"a-arrow__button",attrs:{"type":"button","aria-label":_vm.ariaLabel}},_vm.$listeners),[_vm._t("default",function(){return [_c('svg-icon',{staticClass:"a-arrow__icon",attrs:{"name":"icons/chevron-right"}})]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }